
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
}

slot{
  display:flex;
}

.bottom{
  margin-bottom:2rem;
}

.bottom.accordions{
    margin-bottom:0.75rem;
  }

@media (min-width: 768px){

.bottom.accordions{
      margin-bottom:2.25rem
  }
    }

.reduce-bottom{
  margin-bottom:1rem;
}

.reduce-bottom.accordions{
    margin-bottom:0.75rem;
  }

@media (min-width: 768px){

.reduce-bottom.accordions{
      margin-bottom:1.25rem
  }
    }

.hidden{
  display:none;
}

.feature-grid{
  width:100%;
}

slot[name='main']{
  display:grid;
  grid-template-columns:1fr;
  column-gap:1.5rem;
  row-gap:2.5rem;
}

@media (min-width: 1024px){

slot[name='main']{
    display:grid;
    grid-template-columns:1fr 1fr;
    column-gap:1.5rem;
    row-gap:3rem
}
  }

.feature-grid--columns.accordions > slot[name='main']{
  row-gap:0 !important;
  column-gap:3rem;
}

.feature-grid--columns.single > slot[name='main']{
  grid-template-columns:1fr !important;
}

.feature-grid--top-content{
  display:flex;
  flex-direction:column;
}

@media (min-width: 768px){

.feature-grid--top-content{
    justify-content:space-between;
    align-items:center;
    flex-direction:row
}
  }

.feature-grid--top-content-cta{
  display:flex;
  width:100%;
}

@media (min-width: 768px){

.feature-grid--top-content-cta{
    justify-content:flex-end;
    width:auto
}
  }

@media (min-width: 768px){

.feature-grid--top-content-heading{
    max-width:45%
}
  }

.feature-grid--bottom-content{
  width:100%;
}

slot[name='cta']{
  display:flex;
  flex-direction:column;
}

@media (min-width: 768px){

slot[name='cta']{
    padding-right:3rem;
    flex-direction:row
}
  }

slot[name='cta']::slotted(se-link),
slot[name='cta']::slotted(a){
  align-self:flex-start;
  padding-bottom:0.75rem;
}

@media (min-width: 768px){

slot[name='cta']::slotted(se-link),
slot[name='cta']::slotted(a){
    align-self:center;
    padding-bottom:0
}
  }

@media (min-width: 768px){

slot[name='cta']::slotted(se-link:not(:first-of-type)),
slot[name='cta']::slotted(a:not(:first-of-type)){
    padding-left:3rem
}
  }

slot[name='featured']{
  display:flex;
  padding:1.75rem 0;
}

.bottom.accordions > slot[name='featured']{
  padding:1.75rem 0 0;
}`;